var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 8.33334H5.83341C7.50008 8.33334 8.33341 7.5 8.33341 5.83334V4.16667C8.33341 2.50001 7.50008 1.66667 5.83341 1.66667H4.16675C2.50008 1.66667 1.66675 2.50001 1.66675 4.16667V5.83334C1.66675 7.5 2.50008 8.33334 4.16675 8.33334Z",
    stroke: "#4C4C4C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 8.33334H15.8334C17.5001 8.33334 18.3334 7.5 18.3334 5.83334V4.16667C18.3334 2.50001 17.5001 1.66667 15.8334 1.66667H14.1667C12.5001 1.66667 11.6667 2.50001 11.6667 4.16667V5.83334C11.6667 7.5 12.5001 8.33334 14.1667 8.33334Z",
    stroke: "#4C4C4C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 18.3333H15.8334C17.5001 18.3333 18.3334 17.5 18.3334 15.8333V14.1667C18.3334 12.5 17.5001 11.6667 15.8334 11.6667H14.1667C12.5001 11.6667 11.6667 12.5 11.6667 14.1667V15.8333C11.6667 17.5 12.5001 18.3333 14.1667 18.3333Z",
    stroke: "#4C4C4C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 18.3333H5.83341C7.50008 18.3333 8.33341 17.5 8.33341 15.8333V14.1667C8.33341 12.5 7.50008 11.6667 5.83341 11.6667H4.16675C2.50008 11.6667 1.66675 12.5 1.66675 14.1667V15.8333C1.66675 17.5 2.50008 18.3333 4.16675 18.3333Z",
    stroke: "#4C4C4C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.b623ef4829fb8aa6701961e08331ecb4.svg";
export { ForwardRef as ReactComponent };